import { VehicleNotAvailablePageLabels } from 'libs/shared-lib/interfaces';

export const VEHICLE_NOT_AVAILABLE_LABELS_IT: VehicleNotAvailablePageLabels = {
    headline: '',
    copy: 'Il veicolo non è stato trovato',
    ctaPostText: 'Ulteriori offerte',
};
